import {
  Component,
  EventEmitter,
  Output,
  forwardRef,
  OnInit,
  ElementRef,
  Input
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { NgxsOnInit } from '@ngxs/store';
import { AbstractField } from './abstract-field.component';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CardFieldComponent),
  multi: true
};

@Component({
  selector: 'card-field',
  inputs: [...AbstractField.inputs],
  outputs: [...AbstractField.outputs],
  template: `
    <div
      [floatingLabel]="model"
      [focus]="focused"
      [ngClass]="{
        'validation-failed':
          (showValidation || inp.dirty || inp.touched) &&
          required &&
          (!model || model == '' || !inp.valid)
      }"
    >
      <label for="FIELD={{ id }}">{{ label + (required ? '*' : '') }}</label>
      <input
        [autocomplete]="autocomplete"
        [attr.name]="autocomplete"
        id="FIELD-{{ id }}"
        [(ngModel)]="model"
        [placeholder]="label + (required ? ' *' : '')"
        class="form-control"
        (focus)="focused = true"
        (blur)="onBlur($event)"
        (ngModelChange)="onChange($event)"
        [disabled]="disabled"
        [required]="required"
        #inp="ngModel"
        type="tel"
        ccNumber
        CreditCard
      />
      <cc-indicators
        *ngIf="model && model != ''"
        [number]="model"
      ></cc-indicators>
    </div>
  `,
  providers: [customValueProvider],
  styles: [
    `
      cc-indicators {
        position: absolute;
        top: 12px;
        right: 20px;
      }
    `
  ]
})
export class CardFieldComponent extends AbstractField {
  constructor() {
    super();
  }
}
